module.exports = __webpack_public_path__ + "img/error-500.43cc94b0.jpg";